import "./App.css";
import MailEditor from "./features/mailer/MailEditor";
import { Routes, Route } from "react-router-dom";
import NoPage from "./pages/NoPage";
import AllEmailTemplates from "./pages/AllEmailTemplates";
import AllEmailTemplateFolders from "./pages/AllEmailTemplateFolders";
import RootLayout from "./layout/RootLayout";
import CreateFolder from "./pages/folders/CreateFolder";
import EditFolder from "./pages/folders/EditFolder";
function App() {
  return (
    <>
      <div className="App">
        <Routes>
          <Route path="/:auth/:user_token/:viewType" element={<RootLayout />}>
            <Route index element={<AllEmailTemplateFolders />} />
            <Route path="create-folder" element={<CreateFolder />} />
            <Route path="edit-folder/:folderId" element={<EditFolder />} />
            <Route
              path="templates/:folderName"
              element={<AllEmailTemplates />}
            />
            <Route path="add" element={<MailEditor />} />
            <Route path="add/:folderName" element={<MailEditor />} />
            <Route path="create-temp" element={<MailEditor />} />
            <Route
              path="edit/:tempId"
              element={<MailEditor updating={true} />}
            />
          </Route>
          <Route path="*" element={<NoPage />} />
        </Routes>
      </div>
    </>
  );
}
export default App;
